module.exports = __webpack_public_path__ + "img/a8.94de338f.jpg";